import { settingsActionTypes } from '../../constants/actionTypes/ssapActionTypes';
import { ENABLED, DISABLED } from '../../constants/ssap/miscellaneous/miscellaneous';

export const INITIAL_STATE = {
    collectMemberRemovalReason: DISABLED,
    dacaEffective: null,
    escUiUpdated: DISABLED,
    itfFeature: DISABLED,
    inlineCurrentIncomeEnabled: DISABLED,
    inlineEligibilityIgnoredForEscPage: DISABLED,
    realtimeCheck: DISABLED
};

export default (state = INITIAL_STATE, action = {}) => {
    switch(action.type) {
        case settingsActionTypes.SET_SSAP_SETTINGS:
            return {
                ...state,
                ...action.settings
            };
        case settingsActionTypes.CLEAR_SSAP_STATE:
            return INITIAL_STATE;
        default:
            return state;
    }
};

// Selectors

export const selectIfEscUIEnabled = state => state.escUiUpdated === ENABLED;
export const selectIfInlineEligibilityIgnoredForEscPage = state => state.inlineEligibilityIgnoredForEscPage === ENABLED;
export const selectIsItfFeatureEnabled = state => state.itfFeature === ENABLED;
export const selectIsInlineCurrentIncomeEnabled = state => state.inlineCurrentIncomeEnabled === ENABLED;
export const selectIsMemberRemovalReasonEnabled = state => state.collectMemberRemovalReason === ENABLED;
export const selectDacaEffective = state => state.dacaEffective;
export const selectIfRealtimeCheckEnabled = state => state.realtimeCheck === ENABLED;